import React from 'react';
import { ArrowRight } from 'lucide-react';
interface HeaderProps {
  onNavigateToCheckout?: () => void;
}
export function Header({
  onNavigateToCheckout
}: HeaderProps) {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="absolute top-[103px] md:top-[68px] left-1/2 -translate-x-1/2 z-50 w-full max-w-3xl px-4" data-id="element-282">
      <div className="bg-white rounded-full shadow-lg px-6 py-3 flex items-center justify-between w-full" data-id="element-283">
        {/* Logo Section */}
        <div className="flex items-center" data-id="element-284">
          <img src="https://cdn.magicpatterns.com/uploads/azHZQcNNzPgjKN53Dj7A3N/knova.png" alt="KNOVA Logo" className="h-6 w-auto" data-id="element-285" />
        </div>

        {/* Navigation - Hidden on mobile */}
        <nav className="hidden md:flex items-center gap-6 text-gray-600 font-medium text-sm" data-id="element-286">
          <button onClick={() => scrollToSection('banner')} className="hover:text-black transition-colors cursor-pointer" data-id="element-287">
            Overview
          </button>
          <button onClick={() => scrollToSection('problem-solution')} className="hover:text-black transition-colors cursor-pointer" data-id="element-288">
            Features
          </button>
          <button onClick={() => scrollToSection('easy-to-use')} className="hover:text-black transition-colors cursor-pointer" data-id="element-289">
            Use
          </button>
          <button onClick={() => scrollToSection('reviews')} className="hover:text-black transition-colors cursor-pointer" data-id="element-290">
            Reviews
          </button>
        </nav>

        {/* CTA Button */}
        <button onClick={onNavigateToCheckout} className="bg-black text-white px-5 py-2 rounded-full flex items-center gap-2 font-bold text-sm hover:bg-gray-800 transition-colors" data-id="element-291">
          BUY NOW
          <ArrowRight className="w-4 h-4" data-id="element-292" />
        </button>
      </div>
    </div>;
}